<template>
  <div class="select-row row" v-if="data.length > 0">
    <div class="row__label">{{ label }}</div>
    <div class="row__content">
      <span
        v-for="(item, key, index) in data"
        :key="item.id"
        ref="selectBtn"
        @click="handleClick({ id: item.id, type, index: index + 1 }, $event)"
        class="select-btn"
        :class="[
          { 'select-btn--active': item.id === value }, 
          type === 'datePhase' ? 'phase_box' : ''
        ]"
      >
        <already-degree
          v-if="
            type === 'difficulties' &&
              Number(item.id) === Number($route.query.difficulties) &&
              showDegreeTip
          "
          @closeTip="setShowDegreeTip(false)"
        ></already-degree>
        {{ item.name }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import AlreadyDegree from './AlreadyDegree'

export default {
  name: 'select-row',
  props: ['value', 'data', 'type', 'label'],
  components: { AlreadyDegree },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin,
      showDegreeTip: state => state.CourseCenter.showDegreeTip
    })
  },
  methods: {
    ...mapMutations({
      setShowDegreeTip: 'SET_SHOWDEGREETIP'
    }),
    handleClick(data, event) {
      this.initTips()
      this.$emit('input', data, event)
    },
    computedDegree(data, itemId) {
      const arr = []
      if (this.$store.state.difficultId) {
        for (let i in data) {
          arr.push(data[i].id)
        }
        if (!this.isInArray(arr, this.$store.state.difficultId))
          this.$store.state.difficultId = '0'
        if (itemId === this.$store.state.difficultId) return true
      }
      return false
    },
    isInArray(arr, value) {
      for (let i in arr) {
        if (value === arr[i]) {
          return true
        }
      }
      return false
    },
    initTips() {
      this.setShowDegreeTip(false)
    },
    xesLog(eventName, { type = '', index = '', content = '', clickId = '' }, event) {
      const { subject = 0, grade } = this.$route.params
      const subjectNum = Number(subject)
      const XESLog = new this.$XESLog({
        key: type,
        clickid: clickId,
        content,
        subjectid: subjectNum,
        gradeid: Number(grade)
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(row) {
  line-height: 22px;
  padding: 8px 28px;
  position: relative;
  @include e(label) {
    display: inline-block;
    width: 70px;
    color: #aaaaaa;
    font-weight: normal;
    text-align: left;
    margin-right: 16px;
  }
  @include e(content) {
    display: inline-block;
    position: relative;
    max-width: 950px;
    vertical-align: top;
  }
}
@include b(select-btn) {
  padding: 0 6px;
  margin: 0 6px;
  line-height: 22px;
  display: inline-block;
  color: #333333;
  cursor: pointer;
  position: relative;
  &:hover {
    color: #f13232;
  }
  @include m(active) {
    border-radius: 2px;
    color: #ffffff;
    background: #f13232;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05);
    &:hover {
      color: #ffffff;
    }
  }
}
.phase_box{
  display: inline-block;
  box-sizing: border-box;
  width: 136px;
  height: 25px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// ./src/views/CourseCenter/components/SelectRow.vue